import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type {
  ClassifierValue,
  PredictionObject,
} from "../../../services/api/instances/classificatorApi/types";
import type { CompModel } from "../../../services/api/methodsTypes";
import {
  createClassifierReducerBuilder,
  getAllClassifierObjectVersionsReducerBuilder,
  getAllClassifiersReducerBuilder,
} from "./reducers";
import type { ClassifierState } from "./types";
import { StorageObject } from "../../../services/api/instances/storageApi/types/object_types";

const initialState: ClassifierState = {
  models: [],
  selectedModel: null,
  classifiers: [],
  selectedClassifier: null,
  classifierObjectVersions: [],
  selectedClassifierObjectVersion: null,
  classifierResults: null,
  isClassifiersLoading: false,
};

const classifierSlice = createSlice({
  name: "classifier",
  initialState,
  reducers: {
    setClassifiersAction: (
      state,
      action: PayloadAction<StorageObject<ClassifierValue>[]>,
    ) => {
      state.classifiers = action.payload;
    },

    setSelectedModelAction: (state, action: PayloadAction<CompModel>) => {
      state.selectedModel = action.payload;
    },

    setSelectedClassifierAction: (
      state,
      action: PayloadAction<StorageObject<ClassifierValue> | null>,
    ) => {
      state.selectedClassifier = action.payload;
    },

    setClassifierResultsAction: (
      state,
      action: PayloadAction<PredictionObject | null>,
    ) => {
      state.classifierResults = action.payload;
    },

    setClassifierObjectVersionsAction: (
      state,
      action: PayloadAction<StorageObject<ClassifierValue>[]>,
    ) => {
      state.classifierObjectVersions = action.payload;
    },

    setSelectedClassifierObjectVersionAction: (
      state,
      action: PayloadAction<StorageObject<ClassifierValue> | null>,
    ) => {
      state.selectedClassifierObjectVersion = action.payload;
    },

    clearClassifiersStateAction: () => initialState,
  },
  extraReducers: (builder) => {
    getAllClassifierObjectVersionsReducerBuilder(builder);
    getAllClassifiersReducerBuilder(builder);
    createClassifierReducerBuilder(builder);
  },
});

export const classifierReducer = classifierSlice.reducer;
export const {
  setClassifiersAction,
  setClassifierObjectVersionsAction,
  setSelectedClassifierObjectVersionAction,
  setSelectedClassifierAction,
  setClassifierResultsAction,
} = classifierSlice.actions;
